import Types from "./Types";

const INITIAL_STATE = {
  courses: [],
  course: {},
  enrollRequests: [],
  pendingCourses: [],
  enrollCoursesCount: 0,
  isLoading: false,
  count: "",
};

export default function studentCourses(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ENROLLED_COURSES_SUCCESS: {
      return {
        ...state,
        courses: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_PENDING_COURSES_SUCCESS: {
      return {
        ...state,
        pendingCourses: payload.data,
        count: payload.data.length,
      };
    }

    case Types.ADD_COURSES_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}
